<template>
  <div id="admin-page" v-if="$store.state.userCoopId">
    <template v-if="currentUserSuperAdmin">
      <section class="row" id="add-user-grid">
        <v-snackbar v-model="snackbar" right top :timeout="timeout">
          {{ text }}
        </v-snackbar>
        <user-form
          class="ml-3"
          @submit="submit($event)"
          title="Ajout d'un nouvel utilisateur"
          :no-flag="true"
          :user-creator-id="currentUserId"
          :user-creator-super-admin="currentUserSuperAdmin"
        />
        <v-container class="grid-container" fluid>
          <v-row v-if="loading">
            <v-skeleton-loader max-width="600" type="table" />
          </v-row>
          <v-row v-else>
            <v-col>
              <h5 class="ml-3">Liste des utilisateurs</h5>
              <admin-grid
                class="ml-3"
                :current-time="currentTime"
                :users="users"
                @submit="submit()"
              />
            </v-col>
          </v-row>
        </v-container>
      </section>
    </template>
    <template v-else>
      <v-tabs class="tab-select-bar" v-model="tab" grow>
        <v-tab href="#admin-user-tab">
          <v-icon class="mr-2">person</v-icon>
          Utilisateurs
        </v-tab>
        <v-tab href="#admin-site-tab">
          <v-icon class="mr-2">home_work</v-icon>
          Sites
        </v-tab>
        <v-tab-item class="admin-user-tab" value="admin-user-tab">
          <section class="row" id="add-user-grid">
            <v-snackbar v-model="snackbar" right top :timeout="timeout">
              {{ text }}
            </v-snackbar>
            <user-form
              class="ml-3"
              @submit="submit($event)"
              title="Ajout d'un nouvel utilisateur"
              :no-flag="true"
              :user-creator-id="currentUserId"
              :user-creator-super-admin="currentUserSuperAdmin"
            />
            <v-container class="grid-container" fluid>
              <v-layout>
                <v-flex v-if="!loading">
                  <h5 class="ml-3">Liste des utilisateurs</h5>
                  <admin-grid
                    class="ml-3"
                    :current-time="currentTime"
                    :users="users"
                    @submit="submit()"
                    @update="getAllData()"
                  />
                </v-flex>
              </v-layout>
            </v-container>
          </section>
        </v-tab-item>
        <v-tab-item
          v-if="!currentUserSuperAdmin"
          class="admin-site-tab"
          value="admin-site-tab"
        >
          <section class="row" id="add-site-grid">
            <v-snackbar v-model="snackbar" right top :timeout="timeout">
              {{ text }}
            </v-snackbar>
            <v-container class="grid-container" fluid>
              <v-layout>
                <v-flex v-if="!loading">
                  <h5 class="ml-3">Liste des sites</h5>
                  <site-grid
                    class="ml-3"
                    :sites="sites"
                    @update="getAllData()"
                    @edit-site="editSite($event)"
                  />
                </v-flex>
              </v-layout>
            </v-container>
          </section>
        </v-tab-item>
      </v-tabs>
    </template>
    <confirm-popup
      :show="afterCreateUserPopupConfirm.show"
      :title="afterCreateUserPopupConfirm.title"
      :content="afterCreateUserPopupConfirm.content"
      :width="afterCreateUserPopupConfirm.width"
      :cancelText="afterCreateUserPopupConfirm.cancelText"
      :okText="afterCreateUserPopupConfirm.okText"
      :data="afterCreateUserPopupConfirm.data"
      @close="afterCreateUserPopupConfirmClose"
    />
  </div>
</template>

<script>
import ConfirmPopup from '@/components/modal/ConfirmPopup';
import { mapActions, mapState } from 'vuex';
import { AdminGrid, SiteGrid } from '@/components/AdminGrid/index';
import UserForm from '@/components/Form/UserForm';
import axios from 'axios';

export default {
  components: {
    UserForm,
    AdminGrid,
    SiteGrid,
    ConfirmPopup,
  },
  data() {
    return {
      loading: true,
      user: null,
      users: null,
      currentTime: null,
      snackbar: false,
      tab: null,
      timeout: 4000,
      text: null,
      currentUserId: null,
      currentUserSuperAdmin: false,
      afterCreateUserPopupConfirm: {
        show: false,
        title: "L'utilisateur a été créé",
        content: ``,
        width: 500,
        cancelText: 'Non merci',
        okText: "Confirmer l'envoi de l'email",
        data: {},
      },
    };
  },
  created() {
    this.initialize();
  },
  mounted() {
    this.$store.dispatch('startIntervalTimer', this.getUserChildrenInfos);
  },
  computed: {
    ...mapState(['sites']),
  },
  methods: {
    ...mapActions(['setSites', 'setCooperatives']),
    toast(message) {
      this.snackbar = true;
      this.text = message;
    },
    initialize() {
      // clock updates for import and optimization elapsed time
      this.$store.dispatch('fetchUserInfos').then((userInfos) => {
        window.setInterval(() => {
          this.update();
        }, 1000);
        this.user = userInfos;
        this.currentTime = new Date();
        this.currentUserId = this.$store.state.userId;
        this.currentUserSuperAdmin = userInfos.isSuperAdmin;
        this.getUserChildrenInfos();
        this.setSites();
        this.setCooperatives();
      });
    },
    getAllData() {
      this.getUserChildrenInfos();
      this.setSites();
      this.setCooperatives();
    },
    getUserChildrenInfos() {
      axios({
        method: 'get',
        url: process.env.VUE_APP_BASE_URL + process.env.VUE_APP_USER_CHILDREN,
        headers: {
          'Content-Type': 'application/json',
          user: this.user.email,
        },
      }).then((response) => {
        const res = response.data;
        this.users = res
          .map((user) => {
            user['status'] = {
              authorizations: [user.habImport, user.habOptim],
              startTime: user.dateDebutAction,
              ...this.getUserStatus(user),
            };
            return user;
          })
          .sort((a, b) => {
            return a.email > b.email ? 1 : -1;
          });
        this.loading = false;
      });
    },
    getUserStatus(user) {
      const imp = user.importing;
      const opt = user.optimizing;
      const himp = user.hasImport;
      const hopt = user.hasOptim;
      const obj = { type: null, message: null };

      switch (true) {
        case user.habImport === true && user.habOptim === true:
          obj.message = 'Peut importer et optimiser';
          break;
        case user.habImport === true:
          obj.message = 'Peut importer';
          break;
        default:
          obj.message = 'Ne peut exécuter aucune action';
      }

      switch (true) {
        case user.inconsistance === true:
          obj.type = 'error';
          break;
        case opt === true:
          obj.type = 'optimizing';
          break;
        case imp === true:
          obj.type = 'importing';
          break;
        case hopt === true && himp === true:
          obj.type = 'hasOptim';
          break;
        case himp === true:
          obj.type = 'hasImport';
          break;
        default:
          obj.type = 'none';
      }

      return obj;
    },
    update() {
      this.currentTime = new Date();
    },
    submit(userAdded) {
      axios({
        method: 'post',
        url: process.env.VUE_APP_BASE_URL + process.env.VUE_APP_USER_REPOSITORY,
        headers: {
          'Content-Type': 'application/json',
          user: this.user.email,
        },
        data: {
          ...userAdded,
        },
      })
        .then((response) => {
          this.$toasted.show('Utilisateur ajouté', { type: 'success' });

          this.afterCreateUserPopupConfirm.content = `
            L'utilisateur à été créé. Cependant, il n'a pas encore de mot de passe et ne peut donc pas accéder à la plateforme Optiflux.\n
            Pour remédier à cela, il faut lui envoyer un mail de bienvenue.\n
            Voulez-vous envoyer un mail de bienvenue à ${response.data.email} ?\n
            (Si vous ne souhaitez pas, vous pourrez toujours indiquer à l'utilisateur qu'il pourra utiliser la fonctionnalité 'Mot de passe oublié' pour générer un mot de passe)
          `.trim();
          this.afterCreateUserPopupConfirm.data = {
            response: response,
          };
          this.afterCreateUserPopupConfirm.show = true;
          this.initialize();
        })
        .catch((error) => {
          if (error.response.status === 409) {
            this.$toasted.show('Cette adresse mail est déjà utilisée', {
              type: 'error',
            });
          } else {
            this.$toasted.show("Erreur lors de l'ajout", { type: 'error' });
          }
        });
    },
    editSite(site) {
      const { idSite, ...content } = site;
      axios({
        method: 'patch',
        url:
          process.env.VUE_APP_BASE_URL +
          process.env.VUE_APP_SITE_REPOSITORY +
          '/' +
          idSite,
        headers: {
          'Content-Type': 'application/json',
          user: this.user.email,
        },
        data: {
          ...content,
        },
      })
        .then(() => {
          this.$toasted.show('Site modifié', { type: 'success' });
          this.initialize();
        })
        .catch(() => {
          this.$toasted.show('Erreur de la modification', {
            type: 'error',
          });
        });
    },
    submitSite(site) {
      axios({
        method: 'post',
        url: process.env.VUE_APP_BASE_URL + process.env.VUE_APP_SITE_REPOSITORY,
        headers: {
          'Content-Type': 'application/json',
          user: this.user.email,
        },
        data: {
          site,
        },
      })
        .then(() => {
          this.$toasted.show('Site ajouté', { type: 'success' });
          this.initialize();
        })
        .catch(() => {
          this.$toasted.show("Erreur lors de l'ajout", { type: 'error' });
        });
    },
    afterCreateUserPopupConfirmClose(result) {
      this.afterCreateUserPopupConfirm.show = false;
      if (result.confirm) {
        const response = result.data.response;
        axios({
          method: 'post',
          url:
            process.env.VUE_APP_BASE_URL +
            process.env.VUE_APP_SEND_FORMATTED_MAIL,
          headers: {
            'Content-Type': 'application/json',
            user: this.user.email,
          },
          data: {
            from: this.user.email,
            type: 'BIENVENUE',
            to: response.data.email,
          },
        })
          .then(() => {
            this.$toasted.show(
              'Mail de bienvenue envoyé à ' + response.data.email,
              { type: 'success' }
            );
          })
          .catch(() => {
            this.$toasted.show("Erreur lors de l'envoi du mail", {
              type: 'error',
            });
          });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#admin-page {
  display: block;
  height: calc(100vh - 64px);
  overflow-y: scroll;
  position: relative;

  #add-user-grid,
  #add-site-grid {
    display: inline-block;
    height: auto;
  }
  .grid-container {
    display: inline-block;
    margin-bottom: 48px;
  }
}
</style>
